var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"name-comp-type"},[_c('span',[_vm._v(_vm._s(_vm.title)+":")]),_c(_vm.type,_vm._b({tag:"component",on:{"childEmit":_vm.childEmit}},'component',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }